import WindowResolver from './WindowResolver'


declare global {
  interface Window {
    snaptr(method: string, ...args: any[]): void
  }
}

/*

  From docs:

  window.snaptr('track', ...)

  Usage:

  snaptr.track(...)

 */

const windowEntity = 'snaptr'

const methods = {
  track: true,
  autofill: true,
}

type SnaptrEvent = (
  'PURCHASE' | 'SAVE' | 'START_CHECKOUT' | 'ADD_CART' |
  'VIEW_CONTENT' | 'ADD_BILLING' | 'SIGN_UP' | 'SEARCH' | 'PAGE_VIEW'
)

interface SnaptrData {
  price?: number
  currency?: 'EUR' | 'USD'
  transaction_id?: string
  item_ids?: string[]
  item_category?: string
  description?: string
  search_string?: string
  number_items?: number
  payment_info_available?: 0 | 1
  sign_up_method?: string
  success?: 0 | 1
  [key: string]: any
}

interface ISnaptr {
  track(event: SnaptrEvent, data: SnaptrData): void
  autofill(...args: any[]): void
}

const snaptr = new WindowResolver({
  name: windowEntity,
  methods,
  resolver: () => Boolean(window.snaptr),
  eventHandler: (methodName, ...args) => {
    window.snaptr(methodName, ...args)
  },
}) as unknown as ISnaptr
// TODO: think how to make this work without that shit (as, as)

export default snaptr

export {
  windowEntity,
  methods,
}
